export const izjava_vrtic= {
    templateId: 239.1,
    category: 4,
    templateTitle: 'Izjava o nekorištenju prava na naknadu troška redovne skrbi djeteta radnika kod poslodavca drugog roditelja odnosno izjava o podmirenim troškovima redovne skrbi djeteta od strane drugog poslodavca radnika',
    templateDescription: `<p>Radnik kojemu poslodavac isplaćuje naknadu za trošak redovne skrbi djece u ustanovama predškolskog odgoja, obavezan je poslodavcu prije isplate dostaviti izjavu da nitko drugi (drugi roditelj) već ne koristi pravo na naknadu ovog troška te kopiju računa odnosno dati izjavu poslodavcu jesu li navedeni primici već isplaćeni za isto razdoblje od strane drugog poslodavca.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Neoporezivim primicima smatraju se troškovi redovne skrbi djece radnika u ustanovama predškolskog odgoja.</p>
    <p>Primjerak Odluke kojom se poslodavac obvezuje na isplatu takve naknade možete vidjeti <a class="local-link" href="/contract?template=239">ovdje</a>, zajedno s pripadajućim opisom dokumenta.</p>
    <p><strong>Radnik kojemu poslodavac isplaćuje naknadu za trošak redovne skrbi djece obavezan je poslodavcu prije isplate dostaviti izjavu da nitko drugi (drugi roditelj) već ne koristi pravo na naknadu ovog troška te kopiju računa odnosno jesu li navedeni primici već isplaćeni za isto razdoblje od strane drugog poslodavca te se neoporezivo može isplatiti samo do visine stvarnih izdataka, u tom smislu i izrađen primjerak izjave u nastavku.</strong></p>
    <p>Osim toga, u slučaju da dođe do promjena troška redovne skrbi djeteta radnika ili ako radniku više ne nastaje trošak po toj osnovi, radnik je obvezan o istom obavijestiti poslodavca, a prema primjerku obavijesti <a class="local-link" href="/contract?template=239.2">ovdje</a>.</p>
    <p>Radnik nije obvezan podnijeti pisanu izjavu ukoliko poslodavac ima uvid u podatke putem sustava ePorezna koji se odnose na isplaćene neoporezive primitke koje radnik može ostvariti od više poslodavaca i isplatitelja plaće do određenoga godišnjeg iznosa u poreznom razdoblju.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
      inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "upućuje sljedeću",
    title: "IZJAVU",
  
    noArticleNumbers: true,

    articles: [
      {
        title: "",
        dummy: true, 
        mandatory: true,
        statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: "text", content: "kojom ja, gore navedeni, s danom davanja ove Izjave," },
            { type: "text", content: "u vezi s pravom na naknadu troškova redovne skrbi u ustanovama predškolskog odgoja mojeg djeteta" },
            { type: "input",  required: true, placeholder: "Unesite ime i prezime djeteta," },
            { type: "text", content: ", Poslodavcu" },
            { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
            { type: "text", content: "," },
            { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
            { type: "text", content: ", OIB:" },
            { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
            { type: "text", content: ", izjavljujem sljedeće:" },

          ],
          value: "",
        },
      ]
    },
    {
      title: '',
      mandatory: false,
      dummy: true, 
      statements: [
          {
              type: 'choice',
              mandatory: true,
              choices: [
                  {
                      parts: [
                        { type: "text", content: "tijekom perioda od" },
                        { type: "input",  required: true, placeholder: "Unesite period" },
                        { type: "text", content: "do trenutka davanja ove Izjave, drugi roditelj djeteta ne koristi pravo na naknadu troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja." },
                      ]
                    },
                  {
                      parts: [
                        { type: "text", content: "tijekom perioda od" },
                        { type: "input",  required: true, placeholder: "Unesite period" },
                        { type: "text", content: "do trenutka davanja ove Izjave, drugi roditelj koristi pravo na naknadu dijela troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja, u iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: ", dok je puni mjesečni iznos troškova smještaja " },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." },
                      ]
                    },
                  {
                      parts: [
                        { type: "text", content: "tijekom perioda od" },
                        { type: "input",  required: true, placeholder: "Unesite period" },
                        { type: "text", content: "do trenutka davanja ove Izjave, drugi roditelj koristi pravo na naknadu ukupnog iznosa troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja, u iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." }
                        ]
}],
value: '',
}
]
},
{
  title: '',
  mandatory: false,
  dummy: true, 
  statements: [
      {
          type: 'choice',
          mandatory: true,
          choices: [
              {
                  parts: [
                    { type: "text", content: "tijekom perioda od" },
                    { type: "input",  required: true, placeholder: "Unesite period" },
                    { type: "text", content: "do trenutka davanja ove Izjave, nisam ostvario nikakve isplate na ime naknade troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja kod drugog/drugih poslodavaca.                     " },
                  ]
                },
                 {
                  parts: [
                    { type: "text", content: "tijekom perioda od" },
                    { type: "input",  required: true, placeholder: "Unesite period" },
                    { type: "text", content: "do trenutka davanja ove Izjave, od drugog/drugih poslodavaca primio sam isplate na dijela naknade troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja u iznosu od" },
                    { type: "input",  required: true, placeholder: "Unesite iznos." },
                    { type: "text", content: ", dok je puni iznos troškova" },
                    { type: "input",  required: true, placeholder: "Unesite iznos." },
                  ]
              },
              {
                  parts: [
                    { type: "text", content: "tijekom perioda od" },
                    { type: "input",  required: true, placeholder: "Unesite period" },
                    { type: "text", content: "do trenutka davanja ove Izjave, od drugog/drugih poslodavaca sam primio isplate na ime naknade troškova redovne skrbi gore navedenog djeteta u ustanovama predškolskog odgoja u punom iznosu stvarnih izdataka. " },
                    ]
}],
value: '',
}
]
},
{
  title: '',
  mandatory: true,
  dummy: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Tijekom prethodno naznačenog razdoblja, za gore navedeno dijete su podmireni troškovi redovne skrbi u ustanovama predškolskog odgoja, kako je navedeno prethodno u Izjavi.',
          value: '',
      }],
},
      {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures   
        statements: [],
      },
      {
        static: true,
        mandatory: true,
        editable: true,
        type: 4, 
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
            },
          ],
        },
    ],
    };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/239.1_izjava_vrtic.ts